<script>
export default {
    created(element, binding) {
        const target = binding.value;
        element.classList.add('v-scrollto')
        element.addEventListener('click', () => {
            const targetElm = document.querySelector(target);
            if (!targetElm) {
                return;
            }

            const offset = element.dataset.offset ? element.dataset.offset : 0;

            const bbox = targetElm.getBoundingClientRect();
            window.scrollTo(0, window.scrollY + bbox.top - offset);
        });
    }
}
</script>
<template>ABC {{ target }}</template>
